import { Action, combineReducers, createFeatureSelector } from '@ngrx/store';

import {
  DabHistoryState,
  DAB_HISTORY_FEATURE_KEY,
  reducer as dabHistoryReducer,
  initialState as dabHistoryInitialState,
} from './dab-history.reducer';
import {
  DabItemsState,
  DAB_ITEMS_FEATURE_KEY,
  reducer as dabItemReducer,
  initialState as dabItemInitialState,
} from './dab-items.reducer';

export const DAB_FEATURE_KEY = 'dab';

export interface DabState {
  [DAB_ITEMS_FEATURE_KEY]: DabItemsState;
  [DAB_HISTORY_FEATURE_KEY]: DabHistoryState;
}

export interface DabRootState {
  [DAB_FEATURE_KEY]: DabState;
}

export const initialState: DabState = {
  [DAB_ITEMS_FEATURE_KEY]: dabItemInitialState,
  [DAB_HISTORY_FEATURE_KEY]: dabHistoryInitialState,
};

export function reducers(state: DabState | undefined, action: Action) {
  return combineReducers({
    [DAB_ITEMS_FEATURE_KEY]: dabItemReducer,
    [DAB_HISTORY_FEATURE_KEY]: dabHistoryReducer,
  })(state, action);
}

export const selectDabRootState =
  createFeatureSelector<DabState>(DAB_FEATURE_KEY);
